
class UniversityModel {
    id: number;
    title: string;
    isActive: boolean;

    constructor(
        id: number,
        title: string,
        isActive: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.isActive = isActive;
    }

    public static fromJson(json: any): UniversityModel {
        return new UniversityModel(
            json["id"],
            json["title"],
            json["isActive"],
        );
    }
}


export interface UniversityGetPayloadFilterModel {
    id?: number;
    title?: string;
    isActive?: number;
}

export interface UniversityGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: UniversityGetPayloadFilterModel;
}


export interface UniversityPayloadModel {
    id: number;
    title: string;
    isActive: boolean;

}
export default UniversityModel;
